<template>
  <v-navigation-drawer v-model="show" disable-route-watcher fixed floating right temporary height="100vh" width="350px"
    class="elevation-5">
    <!-- The content -->
    <v-container fluid>
      <!-- The title of the sidebar -->
      <v-layout class="mb-4">
        <v-flex class="text-xs-center blue-grey--text headline font-weight-light">
          Ranking
          <v-btn icon absolute right @click="getMatchRanking">
            <v-icon color="blue-grey">refresh</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <!-- A spinner to show while loading -->
      <v-layout v-if="loadingMatchRanking" class="my-5">
        <v-flex class="text-xs-center">
          <v-pulse-loader :loading="loadingMatchRanking" />
        </v-flex>
      </v-layout>
      <!-- The products -->
      <v-layout v-else wrap>
        <table class="v-list_table">
          <tr>
            <td>
              <label class="text-xs-center blue-grey--text subheading font-weight-light">Hoy ({{ matchRanking.current
              }})</label>
            </td>
          </tr>
          <tr>
            <td>
              <v-list dense class="small-list">
                <v-list-tile v-for="(item, index) in matchRanking.currentDay" :key="index">
                  <v-list-tile-action>
                    <span v-if="index == 0">🏆</span>
                  </v-list-tile-action>

                  <v-list-tile-content>
                    <v-list-tile-title v-text="item.CreatorUser.replace('@qmatch.cl', '')"></v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action v-text="item.Total"> </v-list-tile-action>
                </v-list-tile>

              </v-list>
            </td>
          </tr>
          <tr>
            <td>
              <label class="text-xs-center blue-grey--text subheading font-weight-light">Mes Actual ({{
                matchRanking.currentMonthRange
              }})</label>
            </td>
          </tr>
          <tr>
            <td>
              <v-list dense class="small-list">
                <v-list-tile v-for="(item, index) in matchRanking.currentMonth" :key="index">
                  <v-list-tile-action>
                    <span v-if="index == 0">🏆</span>
                  </v-list-tile-action>

                  <v-list-tile-content>
                    <v-list-tile-title v-text="item.CreatorUser.replace('@qmatch.cl', '')"></v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action v-text="item.Total"> </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </td>
          </tr>
          <tr>
            <td>
              <label class="text-xs-center blue-grey--text subheading font-weight-light">Mes Anterior ({{
                matchRanking.pastMonthRange
              }})</label>

            </td>
          </tr>
          <tr>
            <td>
              <v-list dense class="small-list">
                <v-list-tile v-for="(item, index) in matchRanking.pastMonth" :key="index">
                  <v-list-tile-action>
                    <span v-if="index == 0">🏆</span>
                  </v-list-tile-action>

                  <v-list-tile-content>
                    <v-list-tile-title v-text="item.CreatorUser.replace('@qmatch.cl', '')"></v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action v-text="item.Total"> </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </td>
          </tr>
        </table>

      </v-layout>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapMutations, mapState } =
  createNamespacedHelpers("matching");

// import VItemCard from "./ItemCard";
import VPulseLoader from "vue-spinner/src/PulseLoader";

export default {
  components: {
    // VItemCard,
    VPulseLoader,
  },
  data: () => ({
    rowsPerPageItems: [4, 8, 12],
    pagination: {
      rowsPerPage: 4,
      sortBy: "Total",
      descending: true,
    },
  }),
  computed: {
    ...mapState([
      "loadingMatchRanking",
      "matchRanking",
      "showMatchRankingSidebar",
    ]),
    show: {
      get() {
        return this.showMatchRankingSidebar;
      },
      set(value) {
        this.setShowMatchRankingSidebar(value);
      },
    },
  },
  watch: {
    show() {
      if (this.show && !this.matchRanking.length) {
        this.getMatchRanking();
      }
    },
  },
  methods: {
    ...mapActions(["getMatchRanking"]),
    ...mapMutations(["setShowMatchRankingSidebar"]),
  },
};
</script>
<style>
.small-list {
  padding: 0px;
  /* border: solid red 1px; */
  min-height: 0px;
  /* Adjust the min-height as needed */
}

.v-list--dense .v-list__tile:not(.v-list__tile--avatar) {
  height: 35px !important;
}

/* Apply this style to your table */
.v-list_table {
  /* border: solid blue 1px; */
  width: 100%;
  text-align: left;
  /* Adjust the width as needed */
  border-collapse: collapse;
  /* Collapse borders to reduce space */
  /* font-size: 10px; */
  /* Smaller font size */
}

.v-list_table td,
.v-list_table th {
  padding: 0px;
  /* Minimal padding */
  /* border: 0px solid #ddd; */
  /* Thin borders for definition */
}

.v-list_table tr {
  height: auto;
  /* border: 1px solid red; */
  /* Auto height to fit content */
}
</style>